import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useConfigurator } from "../context/ConfiguratorContext";
import Utils from "../utils";
import Skeleton from "../components/Skeleton";
import TractorSidebar from "./TractorSidebar";

const TractorConfigurator = ({ setCurrentStep }) => {
  const { t } = useTranslation();
  const {
    tractorLoader,
    tractorModelList,
    selectedTractor,
    setSelectedTractor,
    setSelectedTires,
    setSelectedUpgrades,
    setSelectedAttachments,
    setSelectedEquipment,
    setSelectedAccessories,
    lastConfirmedTractorId,
    setLastConfirmedTractorId,
    setLastTractorId,
  } = useConfigurator();

  const [detailsPage, setDetailsPage] = useState(1);

  const handleSelectedModalTractor = (tractor) => {
    setSelectedTractor(tractor);

    if (
      lastConfirmedTractorId !== null &&
      tractor?.id !== lastConfirmedTractorId
    ) {
      setSelectedTires([]);
      setSelectedUpgrades([]);
      setSelectedAttachments([]);
      setSelectedEquipment([]);
      setSelectedAccessories([]);
    }

    setLastConfirmedTractorId(selectedTractor?.id);
    setLastTractorId(null);
  };

  const handleSelectTractor = () => {
    setDetailsPage(2);
  };

  const handleBack = () => {
    setDetailsPage(1);
  };

  const handleContinue = () => {
    const isNewTractor =
      lastConfirmedTractorId !== null &&
      selectedTractor?.id !== lastConfirmedTractorId;
    if (isNewTractor) {
      setSelectedTires([]);
      setSelectedUpgrades([]);
      setSelectedAttachments([]);
      setSelectedEquipment([]);
      setSelectedAccessories([]);
    }

    setLastConfirmedTractorId(selectedTractor?.id);
    setLastTractorId(isNewTractor ? selectedTractor?.id : null);
    setCurrentStep(2);
  };

  return (
    <section className="configuration-section-tractor">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-9">
            {detailsPage === 1 ? (
              <div className="card bg-card card-tractor">
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-12">
                      <h4 className="tractor-heading-main text-start">
                        {t("chooseAModelTractor")}
                      </h4>
                    </div>
                  </div>
                  <div className="tractor-scroll-container custom-scrollbar">
                    <div className="row ">
                      {tractorLoader === true && <Skeleton />}
                      {tractorLoader === false && (
                        <>
                          {tractorModelList && tractorModelList?.length > 0 ? (
                            tractorModelList?.map((tractor, index) => (
                              <div
                                className="col-md-6 col-xl-4 mb-4 main-card equal-height"
                                key={index}
                              >
                                <div
                                  className={`card custom-card custom-card-choose cur-pointer ${
                                    selectedTractor?.id === tractor.id
                                      ? `active`
                                      : ``
                                  }`}
                                  onClick={() =>
                                    handleSelectedModalTractor(tractor)
                                  }
                                >
                                  <div className="position-relative bg-light-gry">
                                    <img
                                      src={tractor.image}
                                      className="card-img-top"
                                      alt={tractor.name}
                                    />
                                  </div>
                                  <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex justify-content-center">
                                        <span className="badge tractor-label-badge tractor-label-badge-custom">
                                          <span className="tractor-label-text">
                                            {tractor.loader_included
                                              ? "Loader"
                                              : "No Loader"}
                                          </span>
                                        </span>
                                      </div>{" "}
                                      <p className="card-price mb-0">
                                        {Utils.priceNumberFormat(tractor.price)}
                                      </p>
                                    </div>

                                    <h6 className="card-title card-title-custom">
                                      {tractor.model} {tractor?.name}
                                    </h6>
                                    <p className="card-text card-description">
                                      {tractor.short_detail}
                                    </p>

                                    {tractor?.attributeList?.length > 0 && (
                                      <div className="row row-cols-2 g-2 small">
                                        {tractor?.attributeList?.map(
                                          (item, idx) => (
                                            <div
                                              key={idx}
                                              className={`col d-flex align-items-center gap-2`}
                                            >
                                              <img
                                                src={item.icon}
                                                alt={item.concat_value}
                                                style={{
                                                  width: "23px",
                                                  height: "23px",
                                                }}
                                              />
                                              <span>
                                                {item.attribute_value}{" "}
                                                {item.concat_value}
                                              </span>
                                            </div>
                                          )
                                        )}
                                      </div>
                                    )}

                                    {tractor?.featureList?.length > 0 && (
                                      <div className="mb-2 mt-2 col-custom-box">
                                        <strong className="d-block mb-2">
                                          {t("standardFeatures")}:
                                        </strong>
                                        <div className="d-flex flex-wrap gap-2">
                                          {tractor?.featureList?.map(
                                            (feature, idx) => (
                                              <span
                                                key={idx}
                                                className="px-3 py-1 border rounded-pill bg-white text-dark text-xs"
                                              >
                                                {feature?.name}
                                              </span>
                                            )
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  {selectedTractor?.id === tractor.id && (
                                    <div
                                      className={
                                        selectedTractor?.id ? "card-footer" : ""
                                      }
                                    >
                                      <span className="badge bg-danger tractor-label-badge-selected">
                                        <span className="tractor-label-text">
                                          <i className="bi bi-check-lg"></i>{" "}
                                          {t("selected")}
                                        </span>
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className={`col-md-12`}>
                              {t("NoModelAvailable")}.
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-12">
                      <h4 className="tractor-heading-main text-start">
                        {selectedTractor?.model || selectedTractor?.name
                            ? `${selectedTractor?.model ?? ''} ${selectedTractor?.name ?? ''}`.trim()
                            : t("chooseAModelTractor")}
                      </h4>
                    </div>
                  </div>
                  <div className="tractor-scroll-container">
                    <div className="row">
                      <div className="col-md-5">
                        <img
                          src={selectedTractor?.image}
                          className="img-fluid custom-img-style"
                          alt="..."
                        />
                      </div>

                      <div className="col-md-7">
                        <div className="feature-list-wrap feature-list-wrap-new">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: selectedTractor.description,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {selectedTractor?.featureList?.length > 0 && (
                      <>
                        <div className="row mb-4 mt-4">
                          <div className="col-12">
                            <h4 className="tractor-heading-main text-start mt-2">
                              {t("standardFeature")}
                            </h4>
                          </div>
                        </div>
                        <div className="tractor-scroll-container">
                          <div className="row">
                            {selectedTractor?.featureList?.map(
                              (item, index) => (
                                <div
                                  className="col-md-3 col-xl-3 equal-height"
                                  key={index}
                                >
                                  <div className="card-tractor-details card custom-card custom-card-choose">
                                    <div className="position-relative">
                                      <img
                                        src={item.image}
                                        className="card-img-top tires-img"
                                        alt={item.name}
                                      />
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                      <h6 className="card-title-custom">
                                        {item.name}
                                      </h6>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item.detail,
                                        }}
                                        className="card-text card-description-details"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-3 mt-4 mt-lg-0">
            <TractorSidebar />

            {detailsPage === 1 ? (
              <button
                className="btn btn-danger mt-3 tractor-custom-button w-100"
                disabled={!selectedTractor}
                onClick={handleSelectTractor}
              >
                <span className="tractor-custom-text">
                  {t("selectThisModal")}
                </span>
              </button>
            ) : (
              <div className="d-flex justify-content-between mt-3">
                <button
                  className="btn btn-outline-theme tractor-custom-button-details"
                  onClick={handleBack}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  {t("back")}
                </button>
                <button
                  className="btn btn-danger tractor-custom-button-details tractor-btn-right"
                  onClick={handleContinue}
                >
                  {t("continue")}
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TractorConfigurator;
